import { router } from 'expo-router';
import { useEffect } from 'react';
import { Linking } from 'react-native';
import { logBreadcrumb } from 'shared/utils/sentry/sentry';

export interface PdfViewerProps {
  url: string;
  onOpen?: () => void;
}

const PdfViewer = ({
  url,
  onOpen,
}: PdfViewerProps): React.JSX.Element | null => {
  useEffect(() => {
    const openLink = async () => {
      try {
        await Linking.openURL(url);
      } catch (error) {
        logBreadcrumb({
          level: 'error',
          message: 'Unable to open PDF url: ' + url + ' : ' + error,
        });
      }
    };

    void openLink();

    if (onOpen) {
      onOpen();
    } else {
      router.back();
    }
  }, [url, onOpen]);

  return null;
};

export default PdfViewer;
